(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easerack-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('easerack-timeline')) {
    customElements.define('easerack-timeline', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-nav]'));
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('[data-viewport]');
        this.previous = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        if (!this.slides.length || !this.track || !this.viewport) return;
        this.index = 0;
        this.classList.add('is-ready');
        this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
        this.previous?.addEventListener('click', () => this.select(this.index - 1), options);
        this.next?.addEventListener('click', () => this.select(this.index + 1), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'Home') return this.select(0);
          if (event.key === 'End') return this.select(this.slides.length - 1);
          this.select(this.index + (event.key === 'ArrowRight' ? (rtl ? -1 : 1) : (rtl ? 1 : -1)));
        }, options);
        this.viewport.addEventListener('touchstart', (event) => {
          this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        this.viewport.addEventListener('touchend', (event) => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.select(this.index + (dx < 0 ? (rtl ? -1 : 1) : (rtl ? 1 : -1)));
        }, { ...options, passive: true });
        this.viewport.addEventListener('touchcancel', () => { this.touchStart = null; }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.select(index, false);
        }, options);
        this.select(0, false);
      }

      disconnectedCallback() { this.controller?.abort(); }

      select(index, announce = true) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.track.style.transform = `translateX(${this.index * (rtl ? 100 : -100)}%)`;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          if (!active && slide.contains(document.activeElement)) this.viewport.focus({ preventScroll: true });
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.buttons.forEach((button, buttonIndex) => button.setAttribute('aria-current', String(buttonIndex === this.index)));
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        if (announce) {
          const title = this.slides[this.index].querySelector('h3').textContent.trim();
          const label = this.buttons[this.index]?.textContent.trim() || '';
          this.status.textContent = `${label} ${title}`;
        }
        const nav = this.buttons[this.index]?.parentElement;
        const button = this.buttons[this.index];
        if (nav && button && nav.scrollWidth > nav.clientWidth) {
          const a = nav.getBoundingClientRect();
          const b = button.getBoundingClientRect();
          if (b.left < a.left || b.right > a.right) nav.scrollBy({ left: b.left - a.left - (a.width - b.width) / 2, behavior: 'instant' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-anchor-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-anchor-tabs')) {
    class ProductAnchorTabs extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.navigation = this.querySelector('.ear-product-tabs__navigation');
        this.buttons = [...this.querySelectorAll('[data-scroll-to]')];
        const resolvedItems = this.buttons.map((button) => ({ button, target: this.findTarget(button.dataset.scrollTo) }));
        resolvedItems.forEach((item) => { item.button.hidden = !item.target; });
        this.items = resolvedItems
          .filter((item) => item.target)
          .sort((a, b) => {
            if (a.target === b.target) return 0;
            const position = a.target.compareDocumentPosition(b.target);
            return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
        this.controller = new AbortController();
        this.buttons.forEach((button) => button.addEventListener('click', () => this.goTo(button), { signal: this.controller.signal }));
        this.querySelector('[data-scroll-top]')?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: this.motion() }), { signal: this.controller.signal });
        window.addEventListener('scroll', () => this.requestUpdate(), { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', () => this.requestUpdate(), { signal: this.controller.signal });
        document.addEventListener('scrollend', () => this.finishNavigation(), { signal: this.controller.signal });
        window.addEventListener('wheel', () => this.finishNavigation(), { passive: true, signal: this.controller.signal });
        window.addEventListener('touchstart', () => this.finishNavigation(), { passive: true, signal: this.controller.signal });
        window.addEventListener('keydown', (event) => {
          if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) this.finishNavigation();
        }, { signal: this.controller.signal });
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this);
        const header = document.querySelector('.shopify-section--header');
        if (header) this.resizeObserver.observe(header);
        this.requestUpdate();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.unlockTimer);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.ready = false;
      }

      findTarget(selector) {
        if (!selector) return null;
        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      offset() {
        const wrapper = this.closest('.shopify-section');
        const top = wrapper ? parseFloat(getComputedStyle(wrapper).top) || 0 : 0;
        return top + this.offsetHeight + (Number(this.dataset.scrollGap) || 0);
      }

      goTo(button) {
        const item = this.items.find((entry) => entry.button === button);
        if (!item) return;
        const behavior = this.motion();
        this.isNavigating = behavior === 'smooth';
        clearTimeout(this.unlockTimer);
        this.activate(button);
        const top = item.target.getBoundingClientRect().top + scrollY - this.offset();
        window.scrollTo({ top: Math.max(0, top), behavior });
        if (this.isNavigating) {
          const fallbackDelay = 'onscrollend' in document ? 2000 : 600;
          this.unlockTimer = setTimeout(() => this.finishNavigation(), fallbackDelay);
        } else {
          this.requestUpdate();
        }
      }

      finishNavigation() {
        if (!this.isNavigating) return;
        this.isNavigating = false;
        clearTimeout(this.unlockTimer);
        this.requestUpdate();
      }

      scrollButtonIntoView(button) {
        if (!this.navigation) return;
        const navigationBounds = this.navigation.getBoundingClientRect();
        const buttonBounds = button.getBoundingClientRect();
        const delta = buttonBounds.left + buttonBounds.width / 2 - (navigationBounds.left + navigationBounds.width / 2);
        if (Math.abs(delta) < 1) return;
        this.navigation.scrollBy({ left: delta, behavior: this.motion() });
      }

      activate(activeButton) {
        if (this.activeButton === activeButton) return;
        this.activeButton = activeButton;
        this.buttons.forEach((button) => {
          const active = button === activeButton;
          button.classList.toggle('active', active);
          button.removeAttribute('aria-current');
          if (active) button.setAttribute('aria-current', 'location');
        });
        this.scrollButtonIntoView(activeButton);
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateActive();
        });
      }

      updateActive() {
        if (!this.items.length || this.isNavigating) return;
        const activationLine = this.offset() + 1;
        let current = this.items[0];

        this.items.forEach((item) => {
          if (item.target.getBoundingClientRect().top <= activationLine) current = item;
        });

        this.activate(current.button);
      }
    }

    customElements.define('product-anchor-tabs', ProductAnchorTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
